import { render, staticRenderFns } from "./ClassGo.vue?vue&type=template&id=d43a287c&scoped=true&"
import script from "./ClassGo.vue?vue&type=script&lang=js&"
export * from "./ClassGo.vue?vue&type=script&lang=js&"
import style0 from "./ClassGo.vue?vue&type=style&index=0&id=d43a287c&lang=less&scoped=true&"
import style1 from "./ClassGo.vue?vue&type=style&index=1&id=d43a287c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d43a287c",
  null
  
)

export default component.exports